export default "__VITE_ASSET__93536e19__"